<template>
  <svg
    width="33"
    height="34"
    viewBox="0 0 33 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.2038 21.7285C28.862 21.2538 27.3347 21.7922 26.5136 23.0076C24.049 26.7025 19.3784 28.4751 15.0356 27.3327C8.46136 25.8148 4.98651 18.0861 8.12146 12.158C11.6572 4.9985 22.122 4.30185 26.5136 10.9912C28.9603 14.4446 33.982 11.1102 31.7656 7.54448C29.4875 4.12206 25.83 1.52271 21.8149 0.546085L21.8196 0.526421C11.2339 -2.20496 0.581843 6.05098 0.683907 16.9999C0.580907 27.947 11.2377 36.2057 21.8196 33.4734L21.8149 33.4528C25.83 32.4762 29.4875 29.8777 31.7656 26.4544C32.9211 24.826 32.1093 22.3409 30.2038 21.7285Z"
      fill="currentColor"
    />
    <path
      d="M21.2749 13.4413C21.0455 13.2119 20.7945 13.004 20.5249 12.8224C20.2552 12.6398 19.9668 12.4834 19.6634 12.3551C19.0566 12.0986 18.3899 11.9562 17.6905 11.9562C16.4648 11.9562 15.3411 12.3907 14.4656 13.1145C13.3382 14.0443 12.6201 15.4517 12.6201 17.0266C12.6201 18.6016 13.3382 20.008 14.4656 20.9378C15.3411 21.6617 16.4648 22.0961 17.6905 22.0961C18.3899 22.0961 19.0566 21.9538 19.6634 21.6972C19.9668 21.569 20.2552 21.4126 20.5249 21.23C20.7945 21.0483 21.0455 20.8405 21.2749 20.6111C21.5043 20.3816 21.7122 20.1307 21.8938 19.861C21.9856 19.7262 22.0699 19.5867 22.1476 19.4425C22.538 18.7243 22.76 17.9012 22.76 17.0266C22.76 16.1511 22.538 15.3281 22.1476 14.6099C22.0699 14.4657 21.9856 14.3262 21.8938 14.1913C21.7122 13.9217 21.5043 13.6707 21.2749 13.4413Z"
      fill="currentColor"
    />
  </svg>
</template>
